export default __webpack_public_path__ + "static/media/commonFolder.c63b77e3.svg";